<template>
    <div
        :class="{
            'vertical-radio': true,
            'vertical-radio--reversed': reversed }">
        <h3 class="vertical-radio__title">
            {{ title }}
        </h3>
        <b-tabs
            vertical
            card
            nav-wrapper-class="vertical-radio__nav"
            nav-class="vertical-radio__items"
            content-class="vertical-radio__content"
            :end="reversed === true && viewportIsLarge">
            <slot />
        </b-tabs>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'VerticalRadio',
    props: {
        reversed: { type: Boolean, default: false },
        title: { type: String, required: true },
    },
    computed: {
        ...mapGetters(['viewportIsLarge']),
    },
};
</script>

<style scoped lang="scss">
.vertical-radio {
  $verticalRadio: &;
  @include font-migrosbank();
  background: $white;
  margin-bottom: 25px;

  @include media-breakpoint-down(xs) {
    margin-bottom: 20px;
  }

  &__title {
    height: 40px;

    @include media-breakpoint-down(xs) {
      height: auto;
    }
  }

  ::v-deep &__nav {
    width: 25%;

    @include media-breakpoint-down(xs) {
      width: 100%;
    }
  }

  ::v-deep &__items {
    padding: 0;
    background-color: $white;

    @include media-breakpoint-down(xs) {
      display: flex;
      flex-direction: row !important;
    }
  }

  ::v-deep &-item {
    @include media-breakpoint-down(xs) {
      flex: 1;

      & ~ .vertical-radio-item {
        margin-left: 5px;
      }
    }
  }

  ::v-deep &__content {
    .card-body {
      padding: 0;
    }
  }

  ::v-deep .vertical-radio-item__button-icon {
    order: 2;
    margin-left: auto;
    margin-right: 1px;
    width: 24px;
    height: 24px;
  }

  ::v-deep .vertical-radio-item-link {
    position: relative;
    padding-left: 15px;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 18px;
    line-height: 18px;
    color: #50585b;
    background-color: $mb-grey2;
    display: flex;
    align-items: center;
    height: 45px;
    margin-bottom: 10px;
    border: 0;

    outline: none;

    @include media-breakpoint-down(xs) {
      font-size: 15px;
      line-height: 12px;
      height: 35px;
    }
  }

  ::v-deep .vertical-radio-item-link.active {
    background-color: $mb-grey-12;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  }

  // arrow
  ::v-deep .vertical-radio-item-link.active:after {
    position: absolute;
    content: "";
    transform: rotate(90deg);
    top: 0;
    height: 50px;
    width: 50px;
    right: -35px;
    border: 25px solid transparent;
    border-bottom-color: $mb-grey-12;

    @include media-breakpoint-down(xs) {
      display: none;
    }
  }

  &--reversed {
    #{$verticalRadio}__title {
      text-align: right;
      padding-right: 80px;

      @include media-breakpoint-down(xs) {
        text-align: left;
        padding-right: 0;
      }
    }

    ::v-deep #{$verticalRadio}-item__body {
      margin-left: 0;
      margin-right: 20px;
    }

    // arrow
    ::v-deep .vertical-radio-item-link.active:after {
      left: -35px;
      transform: rotate(270deg);
    }
  }
}
</style>
